export default __webpack_public_path__ + "static/media/img4.a1c8bb8b.jpg";